/*** Created by qfintern on 18/04/2018  ***/

const protocol = 'https://';
// const protocolB = 'http://';

const path = 'pharmavital-be.quikfox-lab.com';
// const pathB = 'stage-be.appomobile.ch';

const requestConfig = {
    base_url:`${protocol}${path}`,
    grant_type: 'password',
    client_id: '1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
    client_secret: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k'
};

export default requestConfig;



// WEBPACK FOOTER //
// ./src/api-config.js